<script setup lang="ts">
import {
  AirdropItem,
  AirdropItemStatus,
  AirdropStatus,
} from '@sonarwatch/portfolio-core';
import { PropType, computed } from 'vue';

const props = defineProps({
  claimLink: {
    type: String,
    required: true,
  },
  airdropStatus: {
    type: String as PropType<AirdropStatus>,
    required: true,
  },
  item: {
    type: Object as PropType<AirdropItem>,
    required: true,
  },
});

const params = computed(() => {
  if (props.item.isClaimed === true)
    return {
      disabled: true,
      text: 'Claimed',
      color: undefined,
    };
  if (
    props.airdropStatus === AirdropStatus.closed ||
    props.airdropStatus === AirdropStatus.unknowned
  )
    return {
      disabled: false,
      text: 'Check',
      color: 'primary',
    };
  return {
    disabled: false,
    text: 'Claim',
    color: 'primary',
  };
});
</script>

<template>
  <v-btn
    v-if="item.status !== AirdropItemStatus.ineligible"
    height="26"
    :disabled="params.disabled"
    min-width="100px"
    :color="params.color"
    :href="claimLink"
    target="_blank"
    >{{ params.text }}</v-btn
  >
</template>
